import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { DwEventService, DwRoutingService, MODAL_EVENT_CLOSE, MODAL_EVENT_OPEN } from "@devwareapps/devware-cap";
import { filter } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class HelpScoutBeaconService {
  private static beaconVisible?: boolean = null;

  private beaconHiddenRoutes: string[] = ['/', '/manage-users', '/admin', '/lms-admin'];


  constructor(private dwEventService: DwEventService, private dwRoutingService: DwRoutingService, private router: Router) {
    this.setupBeaconEvents();
  }

  setupBeaconEvents() {

    this.dwEventService.getEvent(MODAL_EVENT_OPEN).subscribe(r => {
      //console.log('Modal Opened');
      this.turnOffBeacon();
    });

    this.dwEventService.getEvent(MODAL_EVENT_CLOSE).subscribe(r => {
      //console.log('Modal Closed');
      this.turnOnBeacon();
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe(() => {
        this.setBeaconVisibleForRoute();
      });

    setTimeout(() => {
      this.setBeaconVisibleForRoute();
    }, 500);
  }

  private setBeaconVisibleForRoute() {
    if (!this.dwRoutingService.currentPageUrl) {
      return;
    }

    const beaconVisible = this.getBeaconVisibility(this.dwRoutingService.currentPageUrl);

    if (HelpScoutBeaconService.beaconVisible !== beaconVisible) {
      if (beaconVisible) {
        this.turnOnBeacon();
      } else {
        this.turnOffBeacon();
      }
    }
  }

  private getBeaconVisibility(currentUrl: string): boolean {

    for (let route of this.beaconHiddenRoutes) {
      if (route == '/') {
        if (currentUrl == '/') {
          return false;
        }
      } else {
        if (currentUrl.indexOf(route) >= 0) {
          return false;
        }
      }

    }
    return true;
  }


  turnOnBeacon() {
    console.debug('Turning on beacon');
    const beacon = (window as any).Beacon;

    if (beacon) {
      beacon('init', '8443587c-0b94-4c47-88c2-d7b17a14739f');

      HelpScoutBeaconService.beaconVisible = true;
    }
  }

  turnOffBeacon() {
    console.debug('Turning off beacon');
    const beacon = (window as any).Beacon;

    if (beacon) {
      beacon('close');

      beacon('destroy');
      HelpScoutBeaconService.beaconVisible = false;
    }
  }
}